export type ColorScheme = 'neutral' | 'institute' | 'professionals' | 'professional' | 'festival' | 'collection';

export const colorSchemes: ['neutral', 'institute', 'professionals', 'festival', 'collection'] = [
    'neutral',
    'institute',
    'professionals',
    'festival',
    'collection',
];
